<template lang="html">
  <div id="instruments-charts-app-inner" class="drawer">
    <div v-if="loading" class="drawer__preloader">
      <div class="drawer__dual-ring"></div>
    </div>
    <div class="drawer__filter">
      <ul class="drawer__filter--tabs">
        <li
          v-for="(item, index) in tabs"
          @click="selectedTab = item"
          :key="item" class="drawer__filter--tabs--item"
          :class="{'selected': item === selectedTab}"
        >
          {{tabNames[item]}}
        </li>
      </ul>

      <div class="drawer__selectors">
        <div
          v-for="tab in tabs" :key="'tab_' + tab"
          v-show="selectedTab === tab" class="condition-wrapper"
        >
        
          <div v-if="Array.isArray(filteredInvestmentFunds[tab])">
            <FundsTab @select="selectFund" :type="tab" :data="filteredInvestmentFunds[tab]" :selected-funds="selectedFunds" :colors="randomColor"/>
          </div>
          <div v-else>
            <div v-for="(item,name, index) in filteredInvestmentFunds[tab]" :key="index">
              <h4 class="fund-subtitle">{{name}}</h4>
              <FundsTab @select="selectFund" :type="tab" :data="item" :selected-funds="selectedFunds" :colors="randomColor"/>
            </div>
          </div>

        </div>
        <div v-if="isFundReachedLimit" class="drawer__warning">
          Figyelem! Egyszerre maximum 10 alapot lehet kiválasztani.
        </div>
      </div>
    </div>

    <div class="drawer__filter" v-if="hasTypesSelectors && showFilters">
      <div class="drawer__filter--selectors">
        <h4>Devizák</h4>
        <div class="drawer__filter--selectors--wrapper">
          <div v-for="currency in currencies" :key="currency" class="drawer__checkbox">
            <input type="checkbox" :name="currency" :value="currency" :id="currency" v-model="selectedCurrencies" />
            <label :for="currency">{{currency}}</label>
          </div>
          <div class="drawer__filter--selectors--toggle drawer__checkbox">
            <input type="checkbox" name="toggleCurrency"  id="toggleCurrency"  @click="toggleAll('selectedCurrencies', 'currencies')" :checked="selectedCurrencies.length === this.currencies.length"/>
            <label for="toggleCurrency">összes/egyik sem</label>
          </div>
        </div>
      </div>

      <div class="drawer__filter--selectors">
        <h4>Sorozatok</h4>
        <div class="drawer__filter--selectors--wrapper">
          <div v-for="series in seriesTypes" :key="series"  class="drawer__checkbox">
            <input type="checkbox" :name="series" :value="series" :id="series" v-model="selectedSeriesTypes" />
            <label :for="series">{{series}}</label>
          </div>
          <div class="drawer__filter--selectors--toggle drawer__checkbox">
            <input type="checkbox" name="toggleSeries"  id="toggleSeries" @click="toggleAll('selectedSeriesTypes', 'seriesTypes')" :checked="selectedSeriesTypes.length === seriesTypes.length"/>
            <label for="toggleSeries">összes/egyik sem</label>
          </div>
        </div>
      </div>
    </div>

    <div class="drawer__filter">
      <div class="drawer__filter--selectors w-100 align-items-center">
        <h4>Időtáv</h4>
        <div class="drawer__filter--selectors--wrapper">
           <div class="date-picker__form">
          <DatePicker
            v-model="dateStart"
            mode="date"
            :max-date="dateEnd"
            :masks="dateMasks"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                :value="inputValue"
                v-on="inputEvents"
              />
            </template>
          </DatePicker>
          <svg
            class="w-4 h-4 mx-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            />
          </svg>
          <DatePicker
            v-model="dateEnd"
            mode="date"
            :min-date="dateStart"
            :max-date="new Date()"
            :masks="dateMasks"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                :value="inputValue"
                v-on="inputEvents"
              />
            </template>
          </DatePicker>
          </div>
          <!--
          <DatePicker
            v-model="range"
            is-range
            is-expanded
            title-position="right"
            :max-date="new Date()"
            class="date-picker"
            :masks="dateMasks"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="date-picker__form">
                <input
                  :value="inputValue.start"
                  v-on="inputEvents.start"
                  class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                />
                <svg
                  class="w-4 h-4 mx-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M14 5l7 7m0 0l-7 7m7-7H3"
                  />
                </svg>
                <input
                  :value="inputValue.end"
                  v-on="inputEvents.end"
                  class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                />
              </div>
            </template>
          </DatePicker>
          -->
        </div>
      </div>
    </div>

    <div v-if="isEmptyData" class="drawer__warning w-100 text-center">
      A kiválasztott időtávon a választott alapokkal nincs adat. Kérjük, módosítson a feltételeken.
    </div>

    <div class="drawer__actions w-100 text-right">
      <button class="btn btn-chart btn-chart-reset" @click="resetFundsData()">Alaphelyzetbe állítás</button>
      <button class="btn btn-chart" @click="getRates()" :disabled="selectedFunds.length === 0">Mehet</button>
    </div>

    <div ref="chart"></div>

    <div v-if="Boolean(selectedFunds.length)" class="drawer__selected">
      <h4>Kiválasztott alapok:</h4>
      <span v-for="item in selectedFunds" :key="'selected__' + item">{{getFundName(item)}}</span>
    </div>

    <div v-if="hasSeries" class="drawer__filter drawer__chart" >
      <VueApexCharts height="550" :options="options" :series="series"></VueApexCharts>

      <div class="drawer__chart-type" v-if="showUITypes">
        <button @click="setChartType('area')" :class="{'active': selectedChartType === 'area'}">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKYAAABkCAIAAACDytyfAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAE0NJREFUeJztXYdbW0e23z/sle+93WSTTXspu9kku3Ha9/al2LFTXOKKS0wSxzZxTO8dTBe9SlSBQBIgQAgQ6u3WmVEFhN8RsrEQSAgZkBA63++b797hztHM+d05RdJFf3iclGMmf4j1BJJy2JKk/NhJkvJjJ0nKj50kKT92kqT82EmS8mMnScqPnWyhfH19fSUpCSdAa0jKQbxJSTgJt8uTchwkSfnzCrWKZQ7NrMvg8HpiPZeIJEl59OJZX+1GimuG2uvGuiuGR+nWrtX1tVhPandJUh69DJL5M9qSPKpPiGcbuPEf9FUzTkOsJ7W7JCmPUlp4GXAMTIvwnB817Chsd+MKG+up7SJJyqMRZpVc0FdmWLthf29S3odnzukrutB0rGe3iyQp37M4vO4SevCeubUHKfqJsh/PbSLd2n3X3LoS3xE9SfmeZQArT2tLuvEG31vRyE2kGGvj3LcnKd+bwBaHfQwYIMrtEOK5W6YG8PaxnmY4SVK+NwHvDfVYB5oaIPM7ItfWd8NYH+tphpMk5XsQbs0BVVkJPQDlWShADv+FpsC8wsV6siElSfkepIEdv6iv7sWzQ0Q1SFQB7fzmaQ+aOasrB2cQ68mGlESmfH3jDbK19eDPFaIT2OLn9ZW17NjQBruhAPSnmgSFVP++vOhBSMJSvrru7cOzFcwwkKR0mdzrK8+jbf3xej0ruWKoGSaqYbIQ0Aad+loo4W4aG/ZrIfsuiUk57Ox7lrbrxro8Sphh64bdeUFf2c5PurxREq/xUBDFIU4P2xd2Bbj3k5oivObc30Xtl2yh3Ov1eo6+ON2udlZ2SV/dzsj7+TmAgJZmW3ouGapzrL0au9Xtce9JocPtqqZGrhpqhNzsAK+MBBDyxfz8waxvzxL0kXkC7nLIlr/TldWwYyP2xUD04JlbxgbY7ksuy54UTjq0UJgJeFmQwjBIs7RDtXYw63teSUDKmzkpBF2wu3gbhuyqdGv3ZcMjUcQZtffx+m1T46/mlhH7wnaFoVBGD0FYsXvdB7rS6CTRKGdWSaqpCYLuqH1JvIHRbW0xPXBKWwSptXt9Nbw2yNpkDg34jFZevjl8R51Bpx1o6htdqSEu33lNNMo7+EnYXgNkfnTD+jsC9msTJ71keFRE9UPpFUbbstt201hfzgyDzwijcKeXWPxaWwy3y6EtPHJJNMrvmFseWDvH7OpdUc9NgIfPsvaEYh3SfvAHkO0Df5EoDALUaS287JCXH4kkFOXg1U9rSyDP8hndoQ5ut3WCM7hrbj2rqxgiqqBPPOEUavoUY10Pmgk1PHwnhPMHlo71x+uhZhsrSRzKwbRi+8JtU1M/UUoc6ggBrGfbeqF+K6EHFU49WnNC7c6t2etZiT/tj1xVEFp4OUyGXiWxNkywJA7lDq87nxKW0EMSx/Je0Y1nfjG3fKUphGIMHDLcAd/ryoGzMR95e9bmRx+eg6xCHn/hPHEoh1QLeBLiuXHHcnToJ/NVrLiUHvLX9FHr8QOSuKuGWgEnjbVhgiVxKO9BCqB83KEJwPLW08PuvGtpy7B2x9owwZIglHsfr4Nx0yztEw5N/ADyg4uG6ljbJlgShHK85rxtaqxixDGnORACTnZSUxhv335MEMpVLvN1Y/2wfVHq0MYPRFgJ4XzJbY21ebZIglDezEnvWdp8hnY+gyygjUnnqF1939I+SOZjbZ4tkiCUXzY8qmTEMqcu3gD5fzk9tOub+YcpifB8udnDQUndySti7sm3o5WbhCTD4uFiaJ9wlMOf3UdQetnp87rKAX5egtTxhiFeBbfjNNLG0D7exPuKRAElgkAud+omnfpNdFuMKULqiwb2cg/dpDONE0PgXw8T3+nK+vBMrI30TBKB8quGmlpWEmjlMWz4rIZ7Iw+dqOTezEdv5KPfJ2wye2wov2VqKGeGY22kZ3LkKdd7mJPaIkiUppwGP0Y444eV3IcV/EOJ7aGEgvZCB/NKDvq2lZ0ghs3LDg25lPAXc3P8/LeBI0+5gJNCRR5o4iy57eVs/NMAnT5u8wNYv9TFvJyFfxqiJh2HTXktO37L2BD+uxiHKUebcih+bpua8ijhtNPgRz9l+rCS/6GTzZigMiZsG+0T3O6n/5iOCxXWzYt9cBm2nB5A5wBRpRjrNB4q1tZ6IkebctMK962urA1NTbuMftwQ0n8rRg/HqSzpDjjXzr6UhdsMls3rDwc/m5sHsDLW1noiR5tyqWP5K00R5OoKlxEgtxuBUeA1W0aFwkeV/Of13Chv8g95fsgdxmHGBAqnnSGvKaIH0q1dsbbWEznalNexkjvmlg2z+iisUllfzcV3hplcObUB+unBM6SNMq/noZsiZisrO94Bu3SOY1P6OPVxFf9WAQLXcqWHmXaadryymZef0ZbEyZeijjDlEMihHG/mJ2dcJoAEmc+2s6eauFwZnTdJ50/62iD4Oy90sH98SNr0Vv/AKDDlMN0X0+8Uotfy8KlG/moPe66Ne7MAfS3g+m2W7ddDOP9aW2yKjyeQjzDlsy7jj6ZGsX3Jb9aGZeuLmThNzORvULsBKuD4WWeOjP66iTtRyfdZdqBnVwitFqj3XvZFEC4v4IXAqbySg79s4GQkeIjUob2orx6xL8TaZj45wpQ3cuOppiaIoLMuM5j1eh/zRh4umKILI0C2jIaLL3axU3azfzi0QdjeOeM01y7aoOL/oAw9GGO2v9bPg+zbhShjgg4aDsf3Le2V0b4hA/5s2W3rRNPlzFAdOzbhWPY8x+c0R5jy+5a2LFuv36YybIFde7KRL56mI8SVbvZ/8pFAY9tOdig0qm2QB/yrls+cYEKp/a6F+0s2HuMsQWPr2PFfzM1RLJNdsws46Vl9+RVDDSQuUO+d1ha38vKon346qpTDgiE6tqPpOZcZAMxBZP19jClR0JHjYif350wstFj9SsJgym75XQJlPYEhwGsYnXly5u0CdK2XDdbgNJzS7u0J5NV176RTe0ZXctfSNmxf9OuBuwdi2SXDI6CfRMX6UaVc7tBcM9aK7eo5l2XObbklYj+tRiUKpnRmA5sHgdjWmStj3itFpwXcJLH49ATC/ex4nLfeFzOv5+Lz7cD3LjoBN/q41/OwhLMG6bxsqIm8Ol9b9wrx7GXDozJmWOLQBE1JhOd/NjUXUqIonpg/kpTDOkvpwUJ6AG55pdsy7bC8mIHB0OWzzF6RJ2fBD1/uZhUOC6jaDjmxfFLFv5qD7wxFqr9shoGInuLb6FtUQRj61dwS4ZvtwPf3uvJKRrzjrACD9oVvdKUt3J6fgTqSv7qgdlgu6CuF/NyMwwioUtqA8gwJXaagokDaCA3u/UcRI+VNfoV+TBFjwRQFBfcHpfxv4r0pv9rtu5P6TOZAhW3sJLBocNK7LrCLnz6pKWpkJgKHbwcohHJf47SF1xbuVxfgb2tHQTq4yXO6ilmn2Q+os09UoPIZumI2SmRIGHDFfy/hWzTWAatFZLFUz1s/quLgTvq8DpXvXWGpwncbPRilNycJmHYYIf+YIOowS/OsrvRw03BZN5oJHBsK2ba+m4Z6fsUeRucuP7QR/+JeX7lnaSukBubdVsCMwwpR9t4IV61kngeZE+w3zfy7xRgKsPfLEBzAabqErZyLUmFKL/dJNRLTNv88/cinRGX0UKi34VbW13rxDDiwTqQIHBUGMqcOMvkWXhb5P76KAeXE61p2U3oPg70u797fg9R4qBvG+gGi8q+5RUO9kEGqleyjeQDztGW2nkbamTXB/TrE3R/hiqaiGR7YWTDJvlOIc2RMIENCrIRMmw/xQaoQz100VDdy0gj59gPKFjDIojvS/4ZyqJQ7vZ4CSnRSWwiJ6CVDNbgv/5N/2baeNl4+7zI7d/utCriXU01NkMSq3DbAnNP2VQP/ZT2qVbFxiDMCn7fwT9UPyDd/Njdvf1ANtkE9K4FI38pPBV4fCYD1DFs3mDHCxPDwKLeuoHRr121TE9yVo3Y11Ff9RNWBFJCUplk6Uox1N40Nd8zNsPJxu9q0wu1Yfkw4liGKj9iX/KsdoSmIwan9fJ2KjUOkibmXMonITAcyVMNKbhjrAr/mbFvFJfQgbAPw55Dk75VygIjMg3sYtS9G4t4PiXK85npo7bxlalS4jAtu23ZsvMOghns81SQ4pS3+Vld2y9hQTA8Ax+yq3a+EXiXn9BXg91RPR1XMMv/1O6ma4+oX2DhE1RwLHuhHETfreLbSaafhN2sHRF9g3e51g3u7oK+6a2kT25d2tEwkUEGA4ydBz7LbtisXh0Q57G+IN5NOw4KHWnBTW9qgUw814zL3YmUF69v9Vw21UH1CKQJODwJBET24eeW8i/q+lQfn2bjIxS0yJDxkl516JnCBUqfuvL4SlvOFpgC2gYCTz7ktYQwSSSdsg2vGuhxb7+puG/3AKYfsVOH7Ym85OJ9FD+WDm3pyEIiwnWARMJPSbQns7NIz75fiXBnftMQ1LbK+Ngjx0flqDoQeLmhFwJDcqYc2OoPs2AmB8qqhRubc5Z8YHDjlBg8DCZeAl6s8th2m+xz4aYADyutUnEDNCZY22iDER+eFdvSPcizl6f1d/nbAXq/jxsG9g81jSXkDOw5ObN5tW/LQ+4sTFegbAWpRc3GOkmn+r0UYysh9t8B2KFymm6YGcO8xo1zjpiAV78Vz+762fjPz50ySI+Vbl7n4R0oPAvc+az9wygEQBK8aa4uofmeIT1wOkHIoEzNtPfmUCCKW+umE1NvaKDrnnfT9Ef6rBly/wLUtc22abYizzuIpHm7Qilnu+dceSaeQKMG9N3PSHb88f4CUQ30Ftda4Q6P2MPsLkYl9Kx/nSFG7lj8SaNPw37XgT6pw1EtedDMSmmnXsCM2Fo53vX7UsZzi+1nOGiGehQr5MCiHLZ5irK1hJfvONyBVxL+aQ9o1fKf2yECwxL+cRSpnuciXqXQwnVoutZ//rBr/5wPy3w/Ja7nkpUzyQgY52YDyZdysPdzwKZexmh2DIjDoqYkDoRwKMwEnhZJ62cPsO8YZ9t1ifLMPden4TXQGHMdtJ0T0N/LwGM1GssZcKf9WAf5TOvmwHF/rhsLkmc6mRZ/PeCOPvJKDGxe4Jfcu2lxbvyh3IJRrPdRZXXknmtl4STagZZbcrJxnxTYfYGFwPEtYtZvdfuXW0yediy72Shf6v1osWELdOv5ooXkJ/b0EA/EzmN1xmQrMQh5wudN3GTCdKkLlCtSh2UEVEF+vQreFvivPtaJ+M6d2hzSdyxuacu9+/OqCy+1+RItTDHVKu3nBYQ3EBG3LlHCnGhGsB/C/NfjrRnSxA90Z5POkbL2KEeopBW9T2a1BAzfRtMDAjZ85xnZqmKOILAn7Wg5+IGaD1gWrFiwyQB64gfdLUKqQFSxEpDBfyv61EH1ahevnmVBGc66thKR8X2QAK68ZamVOnWaF3cQU4u4OIWALaL4/jIsmfciegMXjn0T4h3b8ZT3+oMwXq/79N/JCOnmvBH9Rh8+3IXDgMDBrnM+T8bf6EISxh6O4V496DajP4Gs3DwLbeO78fRT/JZtcaEOZEj5NzIPTOlGBX8wgbxeQVBGuUe5ZZ5cO3ejFL2UR2PRSlgs0ux8H69idXs91Y10hPaBeYbQrvpeHdpLnzgjwu8XkziBuVqM+IxIan7X+2bctI/BUlbOQleDfxPh6Lz7bCvcB+biSwK3wjzLyzzL8z3J8bxjDxUHDA0/jvxMYKpSjzx7BovAHpfjTanKpE2dI8CM/2VHp7NTCrkB/KyKnm8A+3LLnieX97QFSDll6Gy//xfeQmAleyY9RypdwflJFqmaRyBgNhAYI275V9emj1BCHAKpgUb37uqKmRQRbC1L6tBGk8XCbFLgPjvIuNA2FuMyp33wx2N8fV+HPqgmsrd+UxIED9n2mBMN2fzMf/zqI2pd5pZ1zhknfopa1x95+PHdeX9nCT+pWOD+meF+Z8X0LERnwoCkQaOtpsnOfOwdMOGscQzSEHf9vaUSq3/JtmS2UE69L5tDsFcNElWvrgyq8AykgeOhWeMCIlf+oAp9pIl1aPGROIgbo0+NGFS6bxhZ7aMoXXJZT2uK94ntdeZqlQ2xXw87Wr/AAKcNDFgqZV58BD1uSiDGQJzTlEOf9nD0PxFYE+Rp4FfDnI5YkYo9wlJPVVTmLFDxSEqR2AX9oG8J1Lrt92TXkDqcaSLeWiK3bgZOdh9+JVkJTPm9b+1cNOd1ILrThm734oRhXKHCnBo9TSOtGhpVw0HpQpcJXfAPf7WoyZiNj1qetdetpsvNwO3EYyiHOl0yS3AnyUEx+6ScXO8iXdeT9UvJKNvmP33ztRxXku2ZyW4ihEiiZxHVKXD+Pq2fxgxH8Xgl5p5A8GCESWxLxhXCUw9/GKbIJ8AlCvW/LNsyT0imSPkpu9RIouj6vJZ9WkU8qfW+NfVzha+H0Rg+pnyejVhKoAV4v8DTZGZPOXSifoEgkAI0jFt8N0acn/Qaf94hwYBKHj3CUk5U1KU2SSDCQ8JTLaPtTkIDjZOcR7tyVcpJEgiEc5e7VNR2yJ5FgAFpDUp6U4yBJyo+dJCk/dpKk/NhJkvJjJ0nKj538P2HB4u1/8ctLAAAAAElFTkSuQmCC" />
        </button>
        <button @click="setChartType('line')" :class="{'active': selectedChartType === 'line'}">
          <img src="data:image/png;base64,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" />
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import FundsTab from "./components/funds-tab.vue";
import {investmentFunds} from './static/alap.js'
import {a_funds} from './static/a_funds.js'
import VueApexCharts from 'vue-apexcharts'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
//Vue.use(VueApexCharts)

//const serviceUrl = window.currentPageUrl ? window.currentPageUrl : 'http://localhost:4444/chart-app/'

export default {
  name: 'App',
  components: {
    VueApexCharts,
    Calendar,
    DatePicker,
    FundsTab
  },

  data () {
    return {
      serviceUrl: null,
      loading: true,
      investmentFunds: investmentFunds,
      investmentFundsPosts: null,
      groupedInvestmentFunds: null,
      groupedByTypeInvestmentFunds: [],
      baseColors: [
        'red-500',
        'pink-500',
        'purple-500',
        'deep-purple-500',
        'indigo-500',
        'blue-500',
        'light-blue-500',
        'cyan-500',
        'teal-500',
        'green-500',
        'light-green-500',
        'lime-500',
        'yellow-500',
        'amber-500',
        'orange-500',
        'deep-orange-500',
        'brown-500',
        'grey-500',
        'blue-grey-500',
        'red-700',
        'pink-700',
        'purple-700',
        'deep-purple-700',
        'indigo-700',
        'blue-700',
        'light-blue-700',
        'cyan-700',
        'teal-700',
        'green-700',
        'light-green-700',
        'lime-700',
        'yellow-700',
        'amber-700',
        'orange-700',
        'deep-orange-700',
        'brown-700',
        'grey-700',
        'blue-grey-700',

        'red-400',
        'pink-400',
        'purple-400',
        'deep-purple-400',
        'indigo-400',
        'blue-400',
        'light-blue-400',
        'cyan-400',
        'teal-400',
        'green-400',
        'light-green-400',
        'lime-400',
        'yellow-400',
        'amber-400',
        'orange-400',
        'deep-orange-400',
        'brown-400',
        'grey-400',
        'blue-grey-400'
      ],
      baseColorsWithHexacode: {
'red-100': '#fee6e4',

'red-900': '#6c0d06',

'red-200': '#fbbdb9',

'red-800': '#981208',

'red-300': '#f9948d',

'red-700': '#c4170b',

'red-400': '#f66c62',

'red-600': '#ef1d0d',

'red-50': '#fef2f1',

'red-500': '#F44336',

'pink-100': '#f9c5d7',

'pink-900': '#48071d',

'pink-200': '#f59bba',

'pink-800': '#720b2e',

'pink-300': '#f1729d',

'pink-700': '#9c0f3f',

'pink-400': '#ed4880',

'pink-600': '#c61350',

'pink-50': '#fbd2e0',

'pink-500': '#E91E63',

'purple-100': '#e0a4eb',

'purple-900': '#17061a',

'purple-200': '#d47ee2',

'purple-800': '#380e3f',

'purple-300': '#c759da',

'purple-700': '#591665',

'purple-400': '#bb33d2',

'purple-600': '#7b1f8a',

'purple-50': '#e4afed',

'purple-500': '#9C27B0',

'deep-purple-100': '#cebeea',

'deep-purple-900': '#190e2c',

'deep-purple-200': '#b49bdf',

'deep-purple-800': '#2c194e',

'deep-purple-300': '#9a78d4',

'deep-purple-700': '#402471',

'deep-purple-400': '#7f56c9',

'deep-purple-600': '#532f94',

'deep-purple-50': '#d6c9ee',

'deep-purple-500': '#673AB7',

'indigo-100': '#c2c8ea',

'indigo-900': '#10142d',

'indigo-200': '#a0a9de',

'indigo-800': '#1b234f',

'indigo-300': '#7e8bd2',

'indigo-700': '#273371',

'indigo-400': '#5c6cc6',

'indigo-600': '#334293',

'indigo-50': '#ccd1ed',

'indigo-500': '#3F51B5',

'blue-100': '#cfe8fc',

'blue-900': '#053358',

'blue-200': '#a4d4fa',

'blue-800': '#074c83',

'blue-300': '#78bff8',

'blue-700': '#0966af',

'blue-400': '#4dabf5',

'blue-600': '#0c7fda',

'blue-50': '#dceffd',

'blue-500': '#2196F3',

'light-blue-100': '#b1e6fe',

'light-blue-900': '#012b3f',

'light-blue-200': '#83d7fd',

'light-blue-800': '#014b6c',

'light-blue-300': '#56c9fd',

'light-blue-700': '#026a99',

'light-blue-400': '#29bafc',

'light-blue-600': '#028ac7',

'light-blue-50': '#beeafe',

'light-blue-500': '#03A9F4',

'cyan-100': '#8df2ff',

'cyan-900': '#00191c',

'cyan-200': '#5fedff',

'cyan-800': '#00424a',

'cyan-300': '#31e8ff',

'cyan-700': '#006b78',

'cyan-400': '#03e2ff',

'cyan-600': '#0093a6',

'cyan-50': '#9af4ff',

'cyan-500': '#00BCD4',

'teal-100': '#4fffef',

'teal-900': 'black',

'teal-200': '#21ffea',

'teal-800': '#000c0b',

'teal-300': '#00f2db',

'teal-700': '#003a35',

'teal-400': '#00c4b2',

'teal-600': '#00685e',

'teal-50': '#5cfff0',

'teal-500': '#009688',

'green-100': '#cae8cc',

'green-900': '#142f15',

'green-200': '#aadaac',

'green-800': '#224f24',

'green-300': '#8acc8d',

'green-700': '#306f33',

'green-400': '#6abe6e',

'green-600': '#3e8f41',

'green-50': '#d4ecd5',

'green-500': '#4CAF50',

'light-green-100': '#e3f1d4',

'light-green-900': '#2c4015',

'light-green-200': '#cde5b1',

'light-green-800': '#446321',

'light-green-300': '#b7da8f',

'light-green-700': '#5c852c',

'light-green-400': '#a1ce6c',

'light-green-600': '#74a838',

'light-green-50': '#eaf4de',

'light-green-500': '#8BC34A',

'lime-100': '#f4f8d5',

'lime-900': '#494f0e',

'lime-200': '#ebf1ae',

'lime-800': '#6d7615',

'lime-300': '#e1ea87',

'lime-700': '#919d1c',

'lime-400': '#d7e360',

'lime-600': '#b6c423',

'lime-50': '#f7fae1',

'lime-500': '#CDDC39',

'yellow-100': '#fffef3',

'yellow-900': '#827500',

'yellow-200': '#fff9c5',

'yellow-800': '#b09e00',

'yellow-300': '#fff497',

'yellow-700': '#dec800',

'yellow-400': '#fff069',

'yellow-600': '#ffe60d',

'yellow-50': 'white',

'yellow-500': '#FFEB3B',

'amber-100': '#ffefbf',

'amber-900': '#4e3b00',

'amber-200': '#ffe391',

'amber-800': '#7c5d00',

'amber-300': '#ffd863',

'amber-700': '#aa8000',

'amber-400': '#ffcc35',

'amber-600': '#d8a200',

'amber-50': '#fff2cc',

'amber-500': '#FFC107',

'orange-100': '#ffe2b8',

'orange-900': '#472b00',

'orange-200': '#ffd08a',

'orange-800': '#754600',

'orange-300': '#ffbd5c',

'orange-700': '#a36100',

'orange-400': '#ffab2e',

'orange-600': '#d17d00',

'orange-50': '#ffe8c5',

'orange-500': '#FF9800',

'deep-orange-100': '#ffe3da',

'deep-orange-900': '#691900',

'deep-orange-200': '#ffc0ac',

'deep-orange-800': '#972400',

'deep-orange-300': '#ff9d7e',

'deep-orange-700': '#c52f00',

'deep-orange-400': '#ff7a50',

'deep-orange-600': '#f33a00',

'deep-orange-50': '#ffede7',

'deep-orange-500': '#FF5722',

'brown-100': '#cdb4ab',

'brown-900': '#060404',

'brown-200': '#bc9b8f',

'brown-800': '#231815',

'brown-300': '#ab8172',

'brown-700': '#3f2d26',

'brown-400': '#966959',

'brown-600': '#5c4137',

'brown-50': '#d2bcb4',

'brown-500': '#795548',

'grey-100': '#fafafa',

'grey-900': '#424242',

'grey-200': '#e3e3e3',

'grey-800': '#595959',

'grey-300': '#cccccc',

'grey-700': '#707070',

'grey-400': '#b5b5b5',

'grey-600': '#878787',

'grey-50': 'white',

'grey-500': '#9E9E9E',

'blue-grey-100': '#c9d4da',

'blue-grey-900': '#151b1e',

'blue-grey-200': '#aebfc7',

'blue-grey-800': '#28343a',

'blue-grey-300': '#93a9b4',

'blue-grey-700': '#3a4c55',

'blue-grey-400': '#7794a1',

'blue-grey-600': '#4d6570',

'blue-grey-50': '#d1dbdf',

'blue-grey-500': '#607D8B',

      },
      chartData: null,
      selectedFunds: [],
      currencies: [],
      selectedCurrencies: [],
      seriesTypes: [],
      selectedSeriesTypes: [],
      selectedColors: [],
      seriesOptionColors: null,
      range: {
        start: new Date(new Date().setDate(new Date().getDate() - 365)),
        end: new Date()
      },
      dateStart: new Date(new Date().setDate(new Date().getDate() - 365)),
      dateEnd: new Date(),
      dateMasks: {
        input: 'YYYY-MM-DD',
        data: 'YYYY-MM-DD'
      },
      tabs: ['premium', 'huf', 'deviza'],
      tabNames: {'premium': 'Prémium alapok', 'huf': 'Forintos lakossági sorozatok', 'deviza': 'Devizás lakossági sorozatok'},
      selectedTab: 'premium',
      chartTypes: ['line', 'area', 'pie'],
      selectedChartType: 'line',
      showFilters: false,
      showUITypes: false
    }
  },

  computed: {
    isInvestmentFundsReady () {
      // eslint-disable-next-line
      return Boolean(this.groupedByTypeInvestmentFunds)
    },

    randomColor () {
      return this.baseColors.sort( () => .5 - Math.random() );
    },

    options () {
      if(!Boolean(this.chartData)) return
      return {
        colors : Object.values(this.seriesOptionColors),
        chart: {
          id: 'aegonpremium-chart',
          type: this.selectedChartType,
          height: 550,
          dropShadow: {
            enabled: true,
            enabledSeries: [0],
            top: -2,
            left: 2,
            blur: 5,
            opacity: 0.06
          }
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        xaxis: {
          //categories: this.chartData[0]
          categories: this.chartData.period
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return parseFloat(value.toFixed(1)) + "%";
            }
          },
          //min: function(min) { return min - 0.5 },
          //max: function(max) { return max + 0.5 },
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          gradient: {
            enabled: this.selectedChartType === 'area' ? true : false,
            opacityFrom: this.selectedChartType === 'area' ? 0.75 : 1,
            opacityTo: this.selectedChartType === 'area' ? 0.25 : 0.75
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          followCursor: true,
          custom: ({series, seriesIndex, dataPointIndex, w}) => {
            //console.log(this.series, seriesIndex,dataPointIndex)
            return this.getFormattedTooltip(dataPointIndex)
            /*
            return '<div class="arrow_box">' +
              '<div class="arrow_box--row"><strong>' + this.series[seriesIndex]['name'] + '</strong>' +
              '<span> - változás: ' + series[seriesIndex][dataPointIndex] + '%</span>' +
              '<span> - árfolyam: ' + this.series[seriesIndex]['rates'][dataPointIndex].toFixed(6) + ' '+ this.series[seriesIndex]['currency'] +'</span><br/>' +
              '</div></div>'*/
          }

        },
        annotations: {
          yaxis: [
            {
              y: 0,
              borderColor: '#00E396',
              label: {
                borderColor: '#00E396',
                style: {
                  color: '#fff',
                  background: '#00E396'
                },
                text: '0%',
                position: 'right',
              }
            }
          ]
        }
      }
    },

    series (){
      if(!Boolean(this.chartData) || this.chartData.series === null || this.chartData.rates === null) return null
      const formatSeries = []
      Object.keys(this.chartData.rates).forEach(item => {
        const {nev, teljes_nev, sorozat, deviza} = this.getFund(item)

        const rates = Object.keys(this.chartData.rates[item].rates).map((key) => {
          return parseFloat(this.chartData.rates[item].rates[key]);
        });
        const percentChanges = Object.keys(this.chartData.rates[item].percentChanges).map((key) => {
          return parseFloat(this.chartData.rates[item].percentChanges[key]);
        });

        formatSeries.push(
          {
            name: `${nev} - ${sorozat} sorozat (${deviza})`,
            fullName: `${teljes_nev} - ${sorozat} sorozat (${deviza})`,
            data: percentChanges,
            rates: rates,
            percentChanges: this.chartData.rates[item].percentChanges,
            currency: deviza
          }
        )

      })
      return formatSeries
    },

    hasSeries () {
      return Boolean(this.series)
    },

    hasTypesSelectors () {
      return Boolean(this.seriesTypes) && Boolean(this.currencies)
    },

    filteredInvestmentFunds () {
      if(!Boolean(this.groupedByTypeInvestmentFunds)) return
      if(!this.showFilters) return this.groupedByTypeInvestmentFunds

      let investmentFunds = this.groupedByTypeInvestmentFunds
      const tempArray = []
      Object.keys(investmentFunds).forEach(item => {
        tempArray[item] = investmentFunds[item]
          .filter(subitem => this.selectedCurrencies.includes(subitem.deviza))
          .filter(subitem => this.selectedSeriesTypes.includes(subitem.sorozat))
      })
      return tempArray
    },

    isEmptyData () {
      if(this.chartData?.series === null || this.chartData?.rates === null) {
        return true
      }
    },

    isFundReachedLimit () {
      return this.selectedFunds.length > 9
    }
  },

  methods: {
    async getFundsDetails() {
      try {
        const data = {
          mode: 'getFundsDetails',
        }
        const response = await this.$axios.post(this.serviceUrl,
          data,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        )
        return response.data;
      } catch (error) {
        alert(error); // catches both errors
        throw error
      }
    },

    groupInstruments () {
      const tempArray = []
      this.investmentFunds.forEach(item => {
        const {sorozat, deviza} = item
        if(!Boolean(tempArray[sorozat])) tempArray[sorozat] = []
        tempArray[sorozat].push(item)

        const indexCurrency = this.currencies.indexOf(deviza)
        if(indexCurrency === -1) this.currencies.push(deviza)
        this.selectedCurrencies = this.currencies

        const indexSeriesType = this.seriesTypes.indexOf(sorozat)
        if(indexSeriesType === -1) this.seriesTypes.push(sorozat)
        this.selectedSeriesTypes = this.seriesTypes
      })
    },

    groupInstrumentsByTypeStatic () {
      const tempArray = {
        'premium': [],
        'deviza': [],
        'huf': [],
      }

      this.investmentFunds.forEach(item => {
        const tempID = parseInt(item.id)
        //console.log(item.id, typeof item.id, parseInt(item.id), this.investmentFundsPosts.findIndex(item => item.instrumentIds.includes(tempID)))
        if(this.investmentFundsPosts.findIndex(item => item.instrumentIds.includes(tempID)) === -1) return
        if(item.teljes_nev.toLowerCase().includes('prémium')) tempArray.premium.push(item)
        else if(item.deviza === 'HUF') tempArray.huf.push(item)
        else tempArray.deviza.push(item)
      })

      Object.keys(tempArray).forEach(item => {
        tempArray[item].sort(function(a, b) {
          return a.nev.localeCompare(b.nev);
        });
      })

      this.groupedByTypeInvestmentFunds = Object.assign({}, tempArray)
    },

    // fill object from window a_funds
    attachFundDetailsToFundsFromPostObject () {
      const tempArray = {
        'premium': [],
        'deviza': {
          'EUR': [],
          'USD': [],
        },
        'huf': [],
      }

      const fillWithData = (fund) => {
        const {id = null, customName = null} = fund
        let details = this.investmentFunds.find(i => parseInt(i.id) === parseInt(id))
        if(!details) details = {}
        if(customName) details.nev = customName
        // if fund is not in the database yet, prevent error, add default values
        if(!details.id) return {
          id,
          nev: customName ?? fund.name,
          deviza: 'N/A',
          isMissingDataFromDatabase: true
        }
        //{"id":"4233","deviza":"TRY","sorozat":"T","nev":"IstanBull","teljes_nev":"Aegon IstanBull Részvény Befektetési Alap","benchmark":"Az alapnak nincs benchmarkja"}        
        return details
      }

      Object.keys(this.investmentFundsPosts).forEach(item => {
        this.investmentFundsPosts[item].forEach(fund => {
          // unfortunate hack because of splitting to eur and usd
          if(item === 'deviza') {
            Object.keys(fund).forEach(devizaFund => {
              fund[devizaFund].forEach(subItem => {
                const details = fillWithData(subItem)
                tempArray[item][devizaFund].push(details)
              })

            })
          } else {
            const details = fillWithData(fund)
            tempArray[item].push(details)
          }

        })
      })
      this.groupedByTypeInvestmentFunds = Object.assign({}, tempArray)
    },

    getFund (id) {
      return this.investmentFunds.find(item => item.id === id)
    },

    selectFund ({id, color}) {
      //if(this.selectedFunds.length === 9) return

      const index = this.selectedFunds.indexOf(parseInt(id))
      if(index > -1) {
        this.selectedFunds.splice(index, 1);
        this.selectedColors.splice(index,1)
      } else {
        if(this.isFundReachedLimit) return        
        this.selectedFunds.push(parseInt(id))
        this.selectedColors.push(this.baseColorsWithHexacode[color])
      }
    },

    getRates () {
      this.loading = true
      this.seriesOptionColors = Object.assign({}, this.selectedColors)
      const formatDate = (date) => {
        const y = date.getFullYear()
        const m = date.getMonth() + 1
        const d = date.getDate()
        const fm = m < 10 ? '0' + m : m
        const fd = d < 10 ? '0' + d : d
        return `${y}-${fm}-${fd}`
      }
      const data = {
        mode: 'getRates',
        id: this.selectedFunds,
        instrumentType: 'type',
        min_date: formatDate(this.dateStart),
        max_date: formatDate(this.dateEnd)
      }

      this.$axios.post(this.serviceUrl,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then(response => {
        if(response.data.error === 'not_exists') {
          this.loading = false;
          alert('Az adatbázis tábla nem létezik!')
          return
        }
        this.chartData = response.data
        this.scrollToElement()
        this.loading = false
      })
      .catch(error => {
        console.error('There was an error!', error);
        this.loading = false
      });

    },

    resetFundsData () {
      this.chartData = null
      this.selectedFunds = []
      this.selectedColors = []
      this.seriesOptionColors = null
      this.selectedCurrencies = this.currencies
      this.selectedSeriesTypes = this.seriesTypes

    },

    toggleAll(type, origin) {
      if(this[type].length > 0) this[type] = []
      else this[type] = this[origin]
    },

    scrollToElement() {
      const el = this.$refs.chart;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({behavior: 'smooth'});
      }
    },

    formatDate (d) {
      // you could also provide your own month names array
      //const months = this.$refs.datePicker.translation.months
      return `${d.getDate().toString().padStart(2, 0)} ${d.getMonth()} ${d.getFullYear()}`
    },

    getFormattedTooltip(index) {
      let html = '';
      this.series.forEach(item => {
        html += `<div class="arrow_box--inner"><strong>${item.name}: </strong><span> változás ${item.data[index]}%</span><span> | árfolyam ${item.rates[index].toFixed(6)} ${item.currency}</span></div>`
      })
      return `<div class="arrow_box">${html}</div>`
    },

    getFundName(id) {
      const {nev = null} = this.investmentFunds.find(i => parseInt(i.id) === id)
      return nev ? nev : id
    },

    isEmptyArray (array) {
        //If it's not an array, return FALSE.
        if (!Array.isArray(array)) {
            return true;
        }
        //If it is an array, check its length property
        if (array.length == 0) {
            //Return TRUE if the array is empty
            return true;
        }
        //Otherwise, return FALSE.
        return false;
    },

    setChartType (type) {
      this.selectedChartType = type
    },

    async init () {
      //console.log(window.a_funds)
      //this.investmentFunds = window.instruments ? window.instruments : investmentFunds
      this.serviceUrl = window.currentPageUrl ? window.currentPageUrl : 'http://localhost:8300/grafikonrajzolo/'
      this.investmentFunds = await this.getFundsDetails()
      this.investmentFundsPosts = window.a_funds ? window.a_funds : a_funds
      await this.groupInstruments()
      await this.attachFundDetailsToFundsFromPostObject()
      this.loading = false
    }

  },

  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  }
}
</script>

<style src="@/assets/colors.css">
</style>

<style lang="scss">
// helpers
.w-100 {
  width: 100%!important;
  flex: 1 0 100%!important;
  max-width: 100%!important;
}

.align-items-center {
  align-items: center;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}


* {
  box-sizing: border-box;
}
</style>

<style scoped lang="scss">
.drawer {
  width: 100%;
  //box-shadow: 0px 2px 16px rgba(0,0,0,0.1);
  font-size: 16px;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 130%;
  background: #fff;
  color: #565656;
  //padding: 20px;
  position: relative;
  margin: 1.5em auto;

  * {
    box-sizing: border-box;
  }

.condition-wrapper {
  width: 100%;

  .fund-subtitle {
    font-weight: 500;
    font-size: 1em;
    text-align: center;
    margin: 15px 0 5px 0;
    padding: 0;
    position: relative;

  }
}

.drawer__selectors {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 1em;

  &--list {
    li {
      &:before {
        content: none!important;
      }      
    }
  }
}

  &__filter {
    width: 100%;
    padding: 10px;
    box-shadow: 0px 2px 16px rgba(0,0,0,0.1);
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1em;

    h4 {
      width: 100%;
      font-size: 1em;
      font-weight: 300;
      margin-top: 0;
      margin-bottom: .5em;
    }

    &--selectors {
      flex: 1 0 50%;
      max-width: 50%;
      width: 50%;
      display: flex;

      @media only screen and (max-width: 768px) {
        flex: 1 0 100%;
        max-width: 100%;
        width: 100%;
        flex-direction: column;
      }


      &--wrapper {
        flex: 1 1 auto;
        flex-wrap: wrap;
      }

      h4 {
        flex: 1;
        margin-bottom: 0;
        margin-right: .5em;

        @media only screen and (max-width: 768px) {
          margin-bottom: .5em;
        }
      }

      div {
        display: inline-flex;
        margin: 0 5px 5px 0;
      }
    }

    &--tabs {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
      width: calc(100% + 20px);
      margin-left: -10px;
      margin-right: -10px;
      margin-top: -10px;
      padding-bottom: 20px;

      &--item {
        flex: 1 1 0;
        text-align: center;
        padding: 10px;
        box-shadow: inset 0px -1px 1px rgba(0,0,0,0.1);
        background: rgba(0,0,0,0.1);
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;


        &:before {
          content: none!important;
        }        

        &.selected {
          background: transparent;
          border-bottom: 1px solid #fff;
          box-shadow: none;
        }
      }
    }
  }

  &__chart {
    width: 100%;
    margin-top: 1em;
    flex-direction: column;
  }

  .date-picker {
    width: 100%;

    &__form {
      display: flex;
      width: 100%;
      align-items: center;

      input {
        //flex: 1 0 25%;
        flex: 1 0 100%;
        //max-width: 25%;
        max-width: 100%;
        width: 100%;
        border: none;
        border-bottom: 1px solid rgba(0,0,0,0.2);
        padding: 10px 0;
        text-align: center;
        font-size: 1.25em;


        @media only screen and (max-width: 768px) {
          flex: 1 1 auto;
          max-width: none;
        }
      }

      svg {
        height: 24px;
        margin: 0 .5em;
      }
    }
  }

  &__warning {
    margin: .5em auto;
    padding: 1em;
     background: #FDC828;
  }

  &__preloader {
    background: rgba(255,255,255,0.8);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;

    &:after {
      content: " ";
      display: block;
      width: 64px;
      height: 64px;
      margin: 8px;
      border-radius: 50%;
      border: 6px solid #fdc828;
      border-color: #fdc828 transparent #fdc828 transparent;
      animation: dual-ring 1.2s linear infinite;
    }
  }
  @keyframes dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &__selected {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: 1em 0;

    h4 {
      margin: 5px 0;
    }

    span {
      display: inline-flex;
      background: rgba(0,0,0,0.05);
      padding: 5px 10px;
      font-size: .75em;
      margin: 3px;
      border-radius: 4px;
    }
  }

  &__checkbox {
    input {
      opacity: 0;
      width: 0;
      height: 0;
      position: absolute;
      top: -9999px;
      left: -9999px;

      &:checked + label {
        background: rgba(0,0,0,0.05);

        &:before {
          background: #FDC828;
          box-shadow: 0px 0px 4px #FDC828;
        }
      }
    }

    label {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 1px solid rgba(0,0,0,0.05);
      border-radius: 4px;
      padding: 4px 10px;
      line-height: 100%;

      &:before {
        display: inline-flex;
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: #e8e8e8;
        box-shadow: 0px 0px 4px rgba(0,0,0,0.1);
        margin-right: 8px;
        margin-left: 0px;
        content: '';
        transition: all .3s ease-in-out;
      }
    }
  }

  &__chart-type {
    display: flex;
    justify-content: center;

    button {
      outline: none;
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 4px;
      background: #fff;
      padding: 5px;
      cursor: pointer;


      &.active img, &:hover img {
        opacity: 1;
        filter: grayscale(0);
      }

      &:first-of-type {
        border-radius: 4px 0 0 4px;
        border-right: none;
      }

      &:last-of-type {
        border-radius: 0 4px 4px 0;
      }

      img {
        height: 44px;
        width: auto;
        opacity: .5;
        transition: all .3s ease-in-out;
        filter: grayscale(1);
      }

    }
  }

  &__warning {
    flex: 1 0 100%;
    width: 100%;
  }

  &__actions {

    @media only screen and (max-width: 768px) {
      text-align: center;
      justify-content: center;
      display: flex;
      flex-wrap: wrap;
    }

  }
}

.btn {
  justify-content: center;
  
  @media only screen and (max-width: 768px) {
    min-width: 100%;
    max-width: 100%;
    margin: 0 5px .5em 5px !important;
  }

  @media only screen and (max-width: 500px) {
    min-width: 0;
    width: 100%;
    margin: 0 auto .5em auto !important;
  }

  &.btn-chart {
    padding: 10px 50px;
    border-radius: 2px;
    background: #FDC828;
    border:1px solid rgba(0,0,0,0.1);
    outline: none;
    border: none;
    font-size: 1em;
    color: #fff;
    box-shadow: 0px 2px 16px rgba(0,0,0,0.1);
    cursor: pointer;
    min-width: 250px;
    text-align: center;
    transition: all .2s ease-in-out;

    @media only screen and (max-width: 768px) {
      order: 1;
    }

    &:disabled {
      cursor: default;
      background: #e8e8e8;
      box-shadow: 0px 2px 4px rgba(0,0,0,0.05);
    }
  }

  &.btn-chart-reset {
    border: 1px solid #FDC828;
    background: #fff;
    color: #FDC828;
    margin-right: .5em;


    @media only screen and (max-width: 768px) {
      order: 2;
    }
  }
}


::v-deep .arrow_box {
    display: block;
    flex-wrap: wrap;
    position: relative;
    background: rgba(255,255,255,0.95);
    box-shadow: 0px 2px 16px rgba(0,0,0,0.15);
    font-size: .8em;
    padding: 10px;
    border-radius: 0;

    &--inner {
      border-bottom: 1px solid rgba(0,0,0,0.1);
      display: block;
      margin: 5px;
    }
  }

</style>
